import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M5.882 8.848s6.832 2.53 6.808 4.71-3.47 2.116-2.806.335c.663-1.781 2.196-2.63 4.173-3.392 1.978-.762 6.855-1.923 6.127-3.743-.727-1.82-14.067-2.088-15.496-.735-1.585 1.513-2.439 12.114-.061 12.545 2.346.432 12.467 1.01 14.91-.265.939-.49.994-4.758.662-5.669"
    />
    <path
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M5.88 8.849s3.675 1.36 5.625 2.946m0 0c.71.576 1.19 1.183 1.184 1.765-.025 2.18-3.47 2.115-2.806.334.336-.902.895-1.565 1.622-2.1Zm0 0c.708-.52 1.576-.917 2.551-1.293 1.978-.762 6.855-1.923 6.127-3.743"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const EmailIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
